import { API } from "aws-amplify";

import { getAPIReq } from "data/libs/authLib";

export const getAdvisors = async ({ hubId }) => {
  const req = await getAPIReq(
    {
      query: `query getAdvisors {
      advisors {
        edges {
          node {
            uuid
            email
            firstName
            lastName
            name
          }
        }
      }
    }
    `,
    },
    { hub: hubId }
  );

  const {
    data: { advisors },
  } = await API.post("HublyAPI", `/graphql`, req);
  return advisors.edges.map(({ node }) => {
    return {
      ...node,
      id: node.uuid,
    };
  });
};

export default getAdvisors;
